(() => {
  const initLanding = (root) => {
    if (!root || root.dataset.shpydaInitialized === 'true') return;
    root.dataset.shpydaInitialized = 'true';


    const logo = root.querySelector('[data-spinnable-logo]');

    if (logo) {
      const sensitivity = Number(root.dataset.logoSpinSensitivity || 7);
      let rotationX = 0;
      let rotationY = 0;
      let velocityX = 0;
      let velocityY = 0;
      let lastX = 0;
      let lastY = 0;
      let lastTime = 0;
      let activePointer = null;
      let animationFrame = null;

      const renderLogo = () => {
        logo.style.transform = `rotateX(${rotationX}deg) rotateY(${rotationY}deg)`;
      };

      const stopInertia = () => {
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }
      };

      const runInertia = () => {
        rotationX += velocityX;
        rotationY += velocityY;
        velocityX *= 0.965;
        velocityY *= 0.965;
        renderLogo();

        if (Math.abs(velocityX) > 0.02 || Math.abs(velocityY) > 0.02) {
          animationFrame = window.requestAnimationFrame(runInertia);
        } else {
          animationFrame = null;
        }
      };

      logo.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) return;
        event.preventDefault();
        stopInertia();
        activePointer = event.pointerId;
        lastX = event.clientX;
        lastY = event.clientY;
        lastTime = performance.now();
        velocityX = 0;
        velocityY = 0;
        logo.classList.add('is-spinning');
        logo.setPointerCapture(event.pointerId);
      });

      logo.addEventListener('pointermove', (event) => {
        if (activePointer !== event.pointerId) return;
        event.preventDefault();

        const now = performance.now();
        const elapsed = Math.max(8, now - lastTime);
        const dx = event.clientX - lastX;
        const dy = event.clientY - lastY;
        const multiplier = sensitivity / 7;

        rotationY += dx * 0.65 * multiplier;
        rotationX -= dy * 0.65 * multiplier;
        velocityY = (dx / elapsed) * 11 * multiplier;
        velocityX = (-dy / elapsed) * 11 * multiplier;

        lastX = event.clientX;
        lastY = event.clientY;
        lastTime = now;
        renderLogo();
      });

      const releaseLogo = (event) => {
        if (activePointer !== event.pointerId) return;
        activePointer = null;
        logo.classList.remove('is-spinning');
        try { logo.releasePointerCapture(event.pointerId); } catch (_) {}
        stopInertia();
        animationFrame = window.requestAnimationFrame(runInertia);
      };

      logo.addEventListener('pointerup', releaseLogo);
      logo.addEventListener('pointercancel', releaseLogo);
      logo.addEventListener('dragstart', (event) => event.preventDefault());
    }

    const trigger = root.querySelector('[data-newsletter-trigger]');
    const panel = root.querySelector('[data-newsletter-panel]');
    const input = root.querySelector('[data-newsletter-input]');
    const success = root.querySelector('[data-newsletter-success]');

    const setNewsletterOpen = (open, focusInput = true) => {
      if (!trigger || !panel) return;
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));

      if (open && focusInput) {
        window.requestAnimationFrame(() => {
          input?.focus();
          success?.focus();
        });
      } else if (!open) {
        trigger.focus({ preventScroll: true });
      }
    };

    trigger?.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      setNewsletterOpen(!isOpen);
    });

    if (success || root.querySelector('.shpyda-newsletter__message--error')) {
      setNewsletterOpen(true, false);
    }

    const scroller = root.querySelector('[data-drops-scroller]');
    const previous = root.querySelector('[data-drops-previous]');
    const next = root.querySelector('[data-drops-next]');

    const getScrollStep = () => {
      const card = scroller?.querySelector('.shpyda-drop');
      if (!card) return 220;
      const styles = window.getComputedStyle(scroller);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return card.getBoundingClientRect().width + gap;
    };

    const updateArrows = () => {
      if (!scroller || !previous || !next) return;
      const max = scroller.scrollWidth - scroller.clientWidth;
      previous.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max - 2;
    };

    previous?.addEventListener('click', () => {
      scroller?.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      scroller?.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });

    scroller?.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    let pointerDown = false;
    let dragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let suppressNextClick = false;

    scroller?.addEventListener('pointerdown', (event) => {
      if (!window.matchMedia('(min-width: 990px)').matches || event.button !== 0) return;
      pointerDown = true;
      dragging = false;
      suppressNextClick = false;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;
    });

    scroller?.addEventListener('pointermove', (event) => {
      if (!pointerDown) return;
      const distance = event.clientX - startX;

      if (!dragging && Math.abs(distance) > 10) {
        dragging = true;
        suppressNextClick = true;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      }

      if (dragging) {
        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - distance;
      }
    });

    const endDrag = (event) => {
      if (!pointerDown) return;
      pointerDown = false;
      if (dragging) {
        dragging = false;
        scroller?.classList.remove('is-dragging');
        try { scroller?.releasePointerCapture(event.pointerId); } catch (_) {}
      }
    };

    scroller?.addEventListener('pointerup', endDrag);
    scroller?.addEventListener('pointercancel', endDrag);
    scroller?.addEventListener('lostpointercapture', () => {
      pointerDown = false;
      dragging = false;
      scroller?.classList.remove('is-dragging');
    });

    scroller?.addEventListener('click', (event) => {
      if (!suppressNextClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressNextClick = false;
    }, true);

    scroller?.addEventListener('wheel', (event) => {
      if (
        window.matchMedia('(min-width: 990px)').matches &&
        Math.abs(event.deltaY) > Math.abs(event.deltaX) &&
        scroller.scrollWidth > scroller.clientWidth
      ) {
        event.preventDefault();
        scroller.scrollLeft += event.deltaY;
      }
    }, { passive: false });

    const radar = root.querySelector('[data-drop-radar]');
    const countdown = radar?.querySelector('[data-radar-countdown]');
    const releaseDate = radar?.dataset.releaseDate?.trim();

    if (radar && countdown && releaseDate) {
      const target = new Date(releaseDate).getTime();

      if (!Number.isNaN(target)) {
        const renderCountdown = () => {
          const remaining = target - Date.now();

          if (remaining <= 0) {
            countdown.textContent = 'Live now';
            return false;
          }

          const days = Math.floor(remaining / 86400000);
          const hours = Math.floor((remaining % 86400000) / 3600000);
          const minutes = Math.floor((remaining % 3600000) / 60000);
          const seconds = Math.floor((remaining % 60000) / 1000);

          countdown.textContent =
            `${String(days).padStart(2, '0')}d ` +
            `${String(hours).padStart(2, '0')}h ` +
            `${String(minutes).padStart(2, '0')}m ` +
            `${String(seconds).padStart(2, '0')}s`;

          return true;
        };

        if (renderCountdown()) {
          const timer = window.setInterval(() => {
            if (!renderCountdown()) window.clearInterval(timer);
          }, 1000);
        }
      }
    }

    root.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
      button.addEventListener('click', async () => {
        try {
          if (window.privacyBanner?.showPreferences) {
            await window.privacyBanner.showPreferences();
            return;
          }

          if (window.Shopify?.customerPrivacy?.showPreferences) {
            await window.Shopify.customerPrivacy.showPreferences();
            return;
          }

          document.dispatchEvent(new CustomEvent('shopify:open-cookie-preferences'));
        } catch (error) {
          console.warn('Unable to open Shopify cookie preferences.', error);
        }
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-shpyda-landing]').forEach(initLanding);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
